/**
 * Hosting Noodle product listings for homepage
 * gameID 6 = Hosting Noodle in MuBots Auth FFM backend
 * Prices are GBP/month for display; billing amounts come from Stripe.
 */
export const HOSTING_NOODLE_GAME_ID = 6;

export const PRODUCT_CATEGORIES = {
  DEDICATED: "dedicated",
  CLOUD: "cloud",
  DEVOP: "devop",
  REMOTE_DESKTOP: "remote",
};

/** Backend productID (pid) -> Hosting Noodle display name for dashboard */
export const PID_TO_DISPLAY_NAME = {
  1: "Noodle DevOp – Standard",
  2: "Noodle DevOp – Pro",
  4: "Noodle Dedicated Instance V01/V02",
  5: "Noodle Dedicated Instance V03",
  6: "Noodle Dedicated Instance V04",
  7: "Noodle Cloud Processing C01",
  8: "Noodle Remote Desktop",
};

export const products = [
  // Noodle Dedicated Instances
  {
    id: "dedicated-v01",
    name: "Noodle Dedicated Instance V01",
    price: 53,
    period: "month",
    category: PRODUCT_CATEGORIES.DEDICATED,
    hasQuantity: false,
    bestFor: "Best value",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 4,
    features: [
      "10 Core CPU",
      "2GB Dedicated GPU",
      "512GB SSD + 120GB SSD",
      "Remote Access Environment",
      "40 Mbps Network Speed",
      "1TB Monthly Bandwidth",
      "97% Uptime Target",
    ],
  },
  {
    id: "dedicated-v02",
    name: "Noodle Dedicated Instance V02",
    price: 56,
    period: "month",
    category: PRODUCT_CATEGORIES.DEDICATED,
    hasQuantity: false,
    bestFor: "Fast storage",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 4,
    features: [
      "10 Core CPU",
      "2GB Dedicated GPU",
      "512GB NVMe + 120GB SSD",
      "Remote Access Environment",
      "40 Mbps Network Speed",
      "1TB Monthly Bandwidth",
      "97% Uptime Target",
    ],
  },
  {
    id: "dedicated-v03",
    name: "Noodle Dedicated Instance V03",
    price: 63,
    period: "month",
    category: PRODUCT_CATEGORIES.DEDICATED,
    hasQuantity: false,
    bestFor: "More power",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 5,
    features: [
      "12 Core CPU",
      "2GB Dedicated GPU",
      "1TB NVMe + 120GB SSD",
      "Remote Access Environment",
      "40 Mbps Network Speed",
      "1TB Monthly Bandwidth",
      "97% Uptime Target",
    ],
  },
  {
    id: "dedicated-v04",
    name: "Noodle Dedicated Instance V04",
    price: 74,
    period: "month",
    category: PRODUCT_CATEGORIES.DEDICATED,
    hasQuantity: false,
    bestFor: "Most powerful",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 6,
    features: [
      "24 Core CPU",
      "4GB Dedicated GPU",
      "1TB SSD + 120GB SSD",
      "Remote Access Environment",
      "40 Mbps Network Speed",
      "1TB Monthly Bandwidth",
      "97% Uptime Target",
    ],
  },
  // Noodle Cloud Processing
  {
    id: "cloud-c01",
    name: "Noodle Cloud Processing C01",
    price: 4.5,
    period: "month",
    category: PRODUCT_CATEGORIES.CLOUD,
    hasQuantity: true,
    bestFor: "For teams",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 7,
    features: [
      "4 Core CPU",
      "Shared Cloud Environment",
      "Managed Infrastructure",
      "97% Uptime Target",
    ],
  },
  // Noodle DevOp (professional DevOps person, per month)
  {
    id: "devop-standard",
    name: "Noodle DevOp – Standard",
    price: 18.76,
    period: "month",
    category: PRODUCT_CATEGORIES.DEVOP,
    hasQuantity: false,
    bestFor: "General workloads",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 1,
    features: [
      "Linux (CentOS, Ubuntu) environments",
      "Windows environments",
      "Virtual servers and cloud hosting",
      "Automation frameworks and software deployment",
      "Runtime environment optimization",
      "Secure remote deployment and configuration",
      "Designed for all general workloads",
      "Compatible with Noodle Dedicated Instances and Noodle Cloud Processing",
    ],
  },
  {
    id: "devop-pro",
    name: "Noodle DevOp – Pro",
    price: 18,
    period: "month",
    category: PRODUCT_CATEGORIES.DEVOP,
    hasQuantity: false,
    bestFor: "Pro & email",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 2,
    features: [
      "All features of Noodle DevOp Standard",
      "Full email server setup and configuration",
      "Multi-environment deployment support",
      "Priority support for deployment requests",
      "Ideal for compute + email server solutions",
      "Compatible with Noodle Dedicated Instances and Noodle Cloud Processing",
    ],
  },
  // Noodle Remote Desktop – display only, downloadable as trial (no purchase)
  {
    id: "remote-desktop",
    name: "Noodle Remote Desktop",
    price: 10,
    period: "month",
    category: PRODUCT_CATEGORIES.REMOTE_DESKTOP,
    hasQuantity: false,
    bestFor: "Remote access",
    gameID: HOSTING_NOODLE_GAME_ID,
    pid: 8,
    trialOnly: true,
    trialDownloadUrl: "https://spacyspace.atl1.cdn.digitaloceanspaces.com/noodle-remote-desktop.exe",
    features: [
      "Free P2P connection",
      "Premium tier",
      "Fast servers",
      "Unlimited connection time",
      "10GB bandwidth",
    ],
  },
];

export const getProductsByCategory = (category) =>
  products.filter((p) => p.category === category);

export const getProductById = (id) => products.find((p) => p.id === id);

export const getProductByPid = (pid) => products.find((p) => Number(p.pid) === Number(pid));
